export default function getPrintPrice(sState, sDispatch, pricingid) {
    
    const abortController = new AbortController();
    let dataProduct = '';
    if (sState.dlayer.length > 0){
      sState.dlayer.forEach(function (d) {
        if (dataProduct !== ''){ dataProduct += ','; }
        dataProduct += d
      });
    }

      const request = {
        userid: sState.userid,
        accountid: sState.aid,
        ident: sState.ident,
        layer: sState.print.layer,
        dlayer: dataProduct,
        pagesize: sState.print.size,
        scale: sState.print.scale,
        orientation : sState.print.orientation,
        extent : sState.printframeextent,
        pricingid: pricingid
      }

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/print/price', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            sDispatch({
              type: "setOrderPrice",
              payload: { price: data}
            });
            sDispatch({
              type: "getprice",
              payload: { getPrice: false}
            });
          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
  }